module.exports = __webpack_public_path__ + "static/media/logoTag.3b8f7cae.png";